import { useColorModeValue } from "@chakra-ui/react"

const usePrimaryColorScheme = () => {
  return useColorModeValue("lightPrimary", "darkPrimary")
}

export default usePrimaryColorScheme
